import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { TranslateService } from '../../../api/translate.service';
import { 
  fieldAddressLine1Col, 
  fieldAddressLine2Col, 
  fieldApprovedByCol, 
  fieldAssetValueCol, 
  fieldBuildingNameCol, 
  fieldCarParkSpacesCol, 
  fieldCompanyTypeCol, 
  fieldCounterPartyCol, 
  fieldCountryCol, 
  fieldCreatedByCol, 
  fieldCurrencyCol,
  fieldCustomerIdCol,
  fieldCustomerNameCol,
  fieldDateCol, 
  fieldDealTypeCol, 
  fieldDedicatedClientNameCol, 
  fieldDistrictCol, 
  fieldGstRateCol, 
  fieldIdCol, 
  fieldInvoiceIdCol, 
  fieldInvoiceTypeCol, 
  fieldLoanCapitalCol, 
  fieldLocalityCol, 
  fieldMiqIdCol, 
  fieldMoneyInTrustCol, 
  fieldOppNumberCol, 
  fieldOpportunityCol, 
  fieldOpportunityInstallmentCol, 
  fieldOpportunitySourceCol, 
  fieldPctCol, 
  fieldPostcodeCol, 
  fieldPrimaryEmployeeFunctionalUnitCol, 
  fieldPrimaryEmployeeFunctionalUnitIdCol, 
  fieldPrimaryEmployeeIdCol, 
  fieldPrimaryEmployeeManagingOfficeCol, 
  fieldPrimaryEmployeeManagingOfficeIdCol, 
  fieldPrimaryEmployeeNameCol, 
  fieldPropertyAreaCol, 
  fieldPropertyManagedCol, 
  fieldPropertySubtypeCol, 
  fieldPropertyTypeCol, 
  fieldPurchaseOrderCol, 
  fieldRegionCol, 
  fieldRepresentedPartyCol, 
  fieldRepRolCol, 
  fieldSizeAreaMeasureCol, 
  fieldSubmittedByCol, 
  fieldSuburbCol, 
  fieldTeamCol, 
  fieldTotalInvoiceAmountCol, 
  fieldTransactionTypeCol
} from '../../../utils/ag-grid/column-defs';

@Injectable({
  providedIn: 'root',
})
export class DsfEngagementCustomerDataService {
  constructor(private translateService: TranslateService) { }

  getHeaders(settings: { middle: any; left: any; right: any }) {
    return [
      {
        header: this.translateService.getTranslation('FINISHLINE_ID'),
        key: 'finishline_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_ID'),
        key: 'invoice_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_TYPE'),
        key: 'transaction_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_DT'),
        key: 'invoice_date',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_TYPE'),
        key: 'invoice_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TEAM_ID'),
        key: 'team',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CURRENCY'),
        key: 'currency',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_NO'),
        key: 'opportunity_number',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_ID'),
        key: 'opportunity',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
        key: 'opportunity_installment_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
        key: 'opportunity_source',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('REP_ROLE'),
        key: 'rep_role',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DSF_TRANSACTION_TYPE'),
        key: 'dsf_transaction_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DEAL_TYPE'),
        key: 'deal_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SETTLEMENT_DATE'),
        key: 'settlement_date',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
        key: 'miq_property_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BUILDING_NAME'),
        key: 'building_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE1'),
        key: 'address_line1',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE2'),
        key: 'address_line2',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('POSTAL_CODE'),
        key: 'postal_code',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUBURB'),
        key: 'suburb',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('DISTRICT'),
        key: 'district',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('LOCALITY'),
        key: 'locality',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('REGION'),
        key: 'region',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COUNTRY'),
        key: 'country',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_TYPE'),
        key: 'property_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_SUBTYPE'),
        key: 'property_subtype',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_SIZE'),
        key: 'property_area',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SIZE_MEASUREMENT'),
        key: 'size_area_measure',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CAR_PARK_SPACES'),
        key: 'car_park_spaces',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ASSET_VALUE'),
        key: 'asset_value',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('LOAN_CAPITAL'),
        key: 'loan_capital',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('LVR'),
        key: 'lvr_pct',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CUSTOMER_FEE'),
        key: 'customer_fee_pct',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ANNUAL_SERVICING'),
        key: 'annual_servicing_pct',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INTEREST_RATE_SPREAD'),
        key: 'interest_rate_spread_pct',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MANAGED_BY_CBRE'),
        key: 'managed_by_cbre',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
        key: 'primary_employee_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
        key: 'primary_employee_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
        key: 'primary_employee_functional_unit_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
        key: 'primary_employee_functional_unit',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
        key: 'primary_employee_managing_office_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
        key: 'primary_employee_managing_office',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CUSTOMER_ID'),
        key: 'customer_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('REPRESENTED_PARTY'),
        key: 'represented_party',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COMPANY_TYPE'),
        key: 'company_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
        key: 'dedicated_client_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_NAME'),
        key: 'counter_party_company_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CUSTOMER_ID'),
        key: 'bill_to_customer_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BILL_TO_CUST'),
        key: 'bill_to_customer_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COMPANY_TYPE'),
        key: 'bill_to_company_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
        key: 'bill_to_dedicated_client_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PURCHASE_ORDER'),
        key: 'purchase_order_number',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MONEY_IN_TRUST'),
        key: 'money_in_trust',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('GST_RATE'),
        key: 'gst_rate',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PAYMENT_DUE_DATE'),
        key: 'payment_due_date',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TOTAL_AMOUNT'),
        key: 'total_invoice_amount',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CREATED_BY'),
        key: 'created_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUBMITTED_BY'),
        key: 'submitted_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('APPROVED_BY'),
        key: 'approved_by',
        width: 30,
        style: { ...settings.middle },
      },
    ];
  }

  getDataSourceSettings(): ColDef[] {
    return [
      {
        ...fieldIdCol,
        field: 'finishline_id',
        headerName: this.translateService.getTranslation('FINISHLINE_ID'),
      },
      {
        ...fieldInvoiceIdCol,
        field: 'invoice_id',
        headerName: this.translateService.getTranslation('INVOICE_ID'),
        cellRenderer: null,
      },
      {
        ...fieldTransactionTypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_TYPE'),
      },
      {
        ...fieldDateCol,
        field: 'invoice_date',
        headerName: this.translateService.getTranslation('INVOICE_DT'),
      },     
      {
        ...fieldInvoiceTypeCol,
        headerName: this.translateService.getTranslation('INVOICE_TYPE'),
      },       
      {
        ...fieldTeamCol,
        headerName: this.translateService.getTranslation('TEAM_ID'),
      },      
      {
        ...fieldCurrencyCol,
        headerName: this.translateService.getTranslation('CURRENCY'),
      },     
      {
        ...fieldOppNumberCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_NO'),
      },   
      {
        ...fieldOpportunityCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_ID'),
      },
      {
        ...fieldOpportunityInstallmentCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
      },
      {
        ...fieldOpportunitySourceCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
      },
      {
        ...fieldRepRolCol,
        field: 'rep_role',
        headerName: this.translateService.getTranslation('REP_ROLE'),
      },      
      {
        ...fieldTransactionTypeCol,
        field: 'dsf_transaction_type',
        headerName: this.translateService.getTranslation('DSF_TRANSACTION_TYPE'),
      },   
      {
        ...fieldDealTypeCol,
        headerName: this.translateService.getTranslation('DEAL_TYPE'),
      },
      {
        ...fieldDateCol,
        field: 'settlement_date',
        width: 200,
        headerName: this.translateService.getTranslation('SETTLEMENT_DATE'),
      },     
      {
        ...fieldMiqIdCol,
        headerName: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
      },   
      {
        ...fieldBuildingNameCol,
        headerName: this.translateService.getTranslation('BUILDING_NAME'),
      },  
      {
        ...fieldAddressLine1Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE1'),
      },
      {
        ...fieldAddressLine2Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE2'),
      },    
      {
        ...fieldPostcodeCol,
        headerName: this.translateService.getTranslation('POSTAL_CODE'),
      },      
      {
        ...fieldSuburbCol,
        headerName: this.translateService.getTranslation('SUBURB'),
      },
      {
        ...fieldDistrictCol,
        headerName: this.translateService.getTranslation('DISTRICT'),
      },
      {
        ...fieldLocalityCol,
        headerName: this.translateService.getTranslation('LOCALITY'),
      },     
      {
        ...fieldRegionCol,
        headerName: this.translateService.getTranslation('REGION'),
      },      
      {
        ...fieldCountryCol,
        headerName: this.translateService.getTranslation('COUNTRY'),
      },   
      {
        ...fieldPropertyTypeCol,
        headerName: this.translateService.getTranslation('PROPERTY_TYPE'),
      },      
      {
        ...fieldPropertySubtypeCol,
        headerName: this.translateService.getTranslation('PROPERTY_SUBTYPE'),
      },    
      {
        ...fieldPropertyAreaCol,
        headerName: this.translateService.getTranslation('PROPERTY_AREA'),
      },                     
      {
        ...fieldSizeAreaMeasureCol,
        headerName: this.translateService.getTranslation('SIZE_AREA_MEASURE'),
      },  
      {
        ...fieldCarParkSpacesCol,
        headerName: this.translateService.getTranslation('CAR_PARK_SPACES'),
      },
      {
        ...fieldAssetValueCol,
        headerName: this.translateService.getTranslation('ASSET_VALUE'),
      },
      {
        ...fieldLoanCapitalCol,
        headerName: this.translateService.getTranslation('LOAN_CAPITAL'),
      },
      {
        ...fieldPctCol,
        field: 'lvr_pct',
        headerName: this.translateService.getTranslation('LVR'),
      },
      {
        ...fieldPctCol,
        field: 'customer_fee_pct',
        headerName: this.translateService.getTranslation('CUSTOMER_FEE'),
      },
      {
        ...fieldPctCol,
        field: 'annual_servicing_pct',
        headerName: this.translateService.getTranslation('ANNUAL_SERVICING'),
      },
      {
        ...fieldPctCol,
        field: 'interest_rate_spread_pct',
        headerName: this.translateService.getTranslation('INTEREST_RATE_SPREAD'),
      },
      {
        ...fieldPropertyManagedCol,
        headerName: this.translateService.getTranslation('MANAGED_BY_CBRE'),
      },
      {
        ...fieldPrimaryEmployeeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
      },      
      {
        ...fieldPrimaryEmployeeNameCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
      },      
      {
        ...fieldPrimaryEmployeeManagingOfficeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
      },      
      {
        ...fieldCustomerIdCol,
        headerName: this.translateService.getTranslation('CUSTOMER_ID'),
      },  
      {
        ...fieldRepresentedPartyCol,
        headerName: this.translateService.getTranslation('REPRESENTED_PARTY'),
      },          
      {
        ...fieldCompanyTypeCol,
        headerName: this.translateService.getTranslation('COMPANY_TYPE'),
      },       
      {
        ...fieldDedicatedClientNameCol,
        headerName: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
      },         
      {
        ...fieldCounterPartyCol,
        field: 'counter_party_company_name',
        headerName: this.translateService.getTranslation('COUNTER_PARTY_NAME'),
      },       
      {
        ...fieldCustomerIdCol,
        field: 'bill_to_customer_id',
        headerName: this.translateService.getTranslation('CUSTOMER_ID'),
      },        
      {
        ...fieldCustomerNameCol,
        field: 'bill_to_customer_name',
        headerName: this.translateService.getTranslation('BILL_TO_CUST'),
      },        
      {
        ...fieldCompanyTypeCol,
        field: 'bill_to_company_type',
        headerName: this.translateService.getTranslation('COMPANY_TYPE'),
      },       
      {
        ...fieldDedicatedClientNameCol,
        field: 'bill_to_dedicated_client_name',
        headerName: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
      },        
      {
        ...fieldPurchaseOrderCol,
        field: 'purchase_order_number',
        headerName: this.translateService.getTranslation('PURCHASE_ORDER'),
      },    
      {
        ...fieldMoneyInTrustCol,
        headerName: this.translateService.getTranslation('MONEY_IN_TRUST'),
      },        
      {
        ...fieldGstRateCol,
        headerName: this.translateService.getTranslation('GST_RATE'),
      },   
      {
        ...fieldDateCol,
        field: 'payment_due_date',
        headerName: this.translateService.getTranslation('PAYMENT_DUE_DATE'),
      },        
      {
        ...fieldTotalInvoiceAmountCol,
        headerName: this.translateService.getTranslation('TOTAL_AMOUNT'),
      },     
      {
        ...fieldCreatedByCol,
        headerName: this.translateService.getTranslation('CREATED_BY'),
      },            
      {
        ...fieldSubmittedByCol,
        headerName: this.translateService.getTranslation('SUBMITTED_BY'),
      },     
      {
        ...fieldApprovedByCol,
        headerName: this.translateService.getTranslation('APPROVED_BY'),
      },                
    ];
  }
}
